import React from 'react';

interface ExploreIconProps {
  className?: string;
  size?: number;
}

const ExploreIcon: React.FC<ExploreIconProps> = ({ className = 'w-5 h-5', size = 24 }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
    >
      <path
        d="M14.9 9.1L13.05 13.05L9.1 14.9L10.95 10.95L14.9 9.1Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C13.6092 3 15.1198 3.42232 16.4274 4.16153"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <path
        d="M17.75 3.75L18.35 5.15L19.75 5.75L18.35 6.35L17.75 7.75L17.15 6.35L15.75 5.75L17.15 5.15L17.75 3.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ExploreIcon;
